import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from 'axios';

import { ToastAction } from '../actions';
import { RequestConstant } from '../constants';

export default function* () {
  yield takeEvery(RequestConstant.REQUEST, request);
}

function* request(action) {
  const { payload: request, toast, subtype } = action;
  const { auth: { api_token: token } = {} } = yield select();
  request.headers = {
    ...request?.headers,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Authorization': `Bearer ${token}`,
  };
  try {
    yield put({ payload: request, type: `${subtype}_REQUEST` });
    const response = yield call(axios, request);
    const { data: { data = {}, message = '' } = {} } = response;
    yield put({ payload: data, type: `${subtype}_SUCCESS` });
    toast && ToastAction.showSuccessToast({ body: message });
  } catch (error) {
    const {
      response: { data: { errors = {}, message = '' } = {} } = {},
    } = error;
    yield put({ payload: errors, type: `${subtype}_ERROR` });
    ToastAction.showWarningToast({ body: `
      <p>${message}</p>
      <p class="mb-0">${Object.values(errors).flat().join('</p><p class="mb-0">')}</p>
    ` });
  }
}
